/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Liveroomnoneopen3Inputs */

const en_liveroomnoneopen3 = /** @type {(inputs: Liveroomnoneopen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Live Room open right now`)
};

const de_liveroomnoneopen3 = /** @type {(inputs: Liveroomnoneopen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerade kein Live Room offen`)
};

/**
* | output |
* | --- |
* | "No Live Room open right now" |
*
* @param {Liveroomnoneopen3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const liveroomnoneopen3 = /** @type {((inputs?: Liveroomnoneopen3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Liveroomnoneopen3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_liveroomnoneopen3(inputs)
	return de_liveroomnoneopen3(inputs)
});
export { liveroomnoneopen3 as "liveRoomNoneOpen" }